<template>
    <div v-show="loading" class="lds-ring" >
        <div></div><div></div><div></div><div></div>
    </div>
</template>

<script>
import Vue from 'vue'


export default Vue.extend({
    name: 'RingLoader',
    props: {
        loading: {
            type: Boolean,
            default: true,
        },
    }
})
</script>

<style scoped>
</style>